import { ErrorHandler, Injectable, inject } from '@angular/core';
import { environment } from '../environments/environment';
import { InstanaService } from './services/instana.service';

@Injectable()
export class InstanaErrorHandler implements ErrorHandler {
    private instana = inject(InstanaService);

    public handleError(error: string | Error) {
        if (environment.instana) {
            this.instana.reportError(error);
        } else {
            throw error;
        }
    }
}
